export const studyBinConstants = {
  FOLDERARRAY: 'STUDY_FOLDERARRAY',
  FOLDERPOP: 'STUDY_FOLDER_POP',
  FOLDERPUSH: 'STUDY_FOLDER_PUSH',
};
